import pdf from '@/sui/tools/pdf'
import go from '@/gojs/go'

function exportExplaurPDF (year, list) {
  const styles = {
    h1: {
      fontSize: 12,
      color: '#6F77D6'
    },

    column: {
      fontSize: 10,
      bold: true,
      alignment: 'center'
    },

    cell: {
      fontSize: 9,
      alignment: 'center'
    },

    ename: {
      fontSize: 6,
      alignment: 'center'
    }
  }

  const columns = [
    {
      text: '\n\n\n\n\n\n\nN° de travail\nSouchier',
      value: (v) => {
        const nb = parseInt(v.value) - go.explaur.rootId
        const box = Math.floor(nb / 81)
        const round = nb % 81
        const letter = Math.floor(round / 9)
        const place = round % 9
        const l = String.fromCharCode(65 + letter)
        return `${v.value}\nB${box + 1}/${place + 1}${l}`
      },
      width: '*'
    },
    {
      text: '\n\n\n\n\n\n\n\nLabel',
      value: (v) => {
        return [
          `${v.label}\n`,
          { style: styles.ename, text: v.surveillance.establishment.name }
        ]
      },
      width: '*'
    },
    {
      text: '\n\n\n\n\n\n\n\nUf',
      key: 'uf',
      width: '*'
    },
    { text: 'Ab Vitek' },
    { text: 'CMI Mupi' },
    { text: 'CMI Dapto' },
    { text: 'UMIC Téi (si touchée)' },
    { text: 'UMIC Van (si touchée)' },
    { text: 'Sau PCR' },
    { text: 'PVL PCR' },
    { text: 'MecA PCR' },
    { text: 'MecC PCR' },
    { text: 'Tsst PCR' },
    { text: 'Qac A/B PCR' },
    { text: 'Qac C PCR' },
    { text: 'MupA PCR' },
    { text: 'MupB PCR' },
    { text: 'Spa Type' },
    { text: 'arcC' },
    { text: 'aroE' },
    { text: 'glpF' },
    { text: 'gmk' },
    { text: 'pta' },
    { text: 'tpi' },
    { text: 'yqiL' },
    { text: 'CC' },
    { text: 'ST' },
    { text: 'BFI' }
  ]

  const widths = []
  const header = []

  columns.forEach(
    c => {
      widths.push(c.width == null ? 20 : c.width)
      if (c.width) {
        header.push({ text: c.text, style: 'column' })
      } else {
        header.push(
          {
            svg: `<svg>
 <path id="vertical" fill="none"
        d="M14,100 V0" />
  <text font-size="10" font-weight="bold">
    <textPath href="#vertical">
${c.text}
    </textPath>
  </text>
</svg>`,
            width: 25,
            height: 100
          }
        )
      }
    }
  )

  const body = [header]
  for (let i = 0; i !== 1; ++i) {
    list.forEach(
      l => {
        const line = []
        columns.forEach(
          c => {
            const v = c.key == null ? c.value == null ? '' : c.value(l) : l[c.key]
            line.push({ text: v, style: 'cell' })
          }
        )
        body.push(line)
      }
    )
  }

  const content = [
    {
      fontSize: 7,
      layout: {
        hLineWidth: function (i, node) {
          return 1
        },

        vLineWidth: function (i, node) {
          return 1
        },

        hLineColor: function (i, node) {
          return 'black'
        },

        paddingLeft (i) {
          return i === 0 ? 0 : 1
        },

        paddingRight (i, node) {
          return (i < node.table.widths.length - 1) ? 1 : 0
        }
      },

      table: {
        dontBreakRows: true,
        widths: widths,
        body: body
      }
    }
  ]

  const definition = {
    pageStyle: 'A4',
    pageOrientation: 'landscape',
    content: content,
    styles: styles,
    images: {
      checkbox: pdf.checkbox
    }
  }
  const filename = `SPIADI${year} - RÉA-EXPLAUR.pdf`
  pdf.createPdf(definition).download(filename)
}

export default {
  exportExplaurPDF
}
